









































































import { mixins } from "vue-class-component";
import { Component, Prop, Vue } from "vue-property-decorator";
import {
  NavBar,
  Image,
  Tabbar,
  TabbarItem,
  Search,
  Field,
  Picker,
  Popup,
  Button,
  Toast,
  List,
  Cell,
  CellGroup,
  Dialog,
  Tag,
  Icon,
  Row,
  Col,
  NoticeBar,
  Loading,
  Card,
  Form,
} from "vant";
import WeMixin from "@/components/weMixin";
import api from "../../../components/http/api";
import { CouponRequestInfo } from "./CouponApi";

@Component({
  components: {
    [NavBar.name]: NavBar,
    [Image.name]: Image,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Card.name]: Card,
    [Search.name]: Search,
    [Field.name]: Field,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [List.name]: List,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Tag.name]: Tag,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [NoticeBar.name]: NoticeBar,
    [Loading.name]: Loading,
    [Form.name]: Form,
  },
})
export default class GetCouponFromNotifyResult498 extends mixins(WeMixin) {
  private couponRequestInfo: CouponRequestInfo = {} as CouponRequestInfo;
  private show: boolean = true;
  private showResult: boolean = false;
  private showResult1: boolean = false;
  private msg: string = "";
  private msg1: string = "";
  private msg2: string = "";
  protected created() {
    this.couponRequestInfo.openid = this.$route.query.d as string;
    this.couponRequestInfo.phone = this.$route.query.b as string;
    this.couponRequestInfo.activityid = this.$route.query.c as string;
    this.couponRequestInfo.orgid = this.$route.query.a as string;
    this.couponRequestInfo.couponopenid = this.$route.query.openid as string;
    this.couponRequestInfo.source = this.$route.query.e as string;
    console.log(this.couponRequestInfo);
    api
      .post("/weixinmp/xsyx/coupon/getCouponFromNotify", this.couponRequestInfo)
      .then((res: any) => {
        if (res.data.EIFlag) {
          this.show = false;
          this.showResult = true;
          this.showResult1 = false;
          this.msg = res.data.msg;
          this.msg1 = res.data.msg1;
          this.msg2 = res.data.msg2;
        } else {
          this.show = false;
          this.showResult = false;
          this.showResult1 = true;
          this.msg = res.data.msg;
          this.msg1 = res.data.msg1;
          this.msg2 = res.data.msg2;
        }
      });
  }
}
